import { PropsWithChildren, ReactElement } from 'react';
import styles from './DashboardSection.module.scss';
import { VdsIcon, VdsTooltip } from '@volt/volt-extended-components-react';

interface DashboardSectionProps {
  title: string;
  subtitle?: string;
  tooltip?: string;
  action?: ReactElement;
}

export function DashboardSection({
  title,
  subtitle,
  tooltip,
  action,
  children,
}: PropsWithChildren<DashboardSectionProps>) {
  return (
    <section className={styles.section}>
      <header className={styles.header}>
        <div className={styles.heading}>
          <div className={styles.heading__title}>{title}</div>

          <div className={styles.heading__subtitle}>
            <span>{subtitle}</span>
            {typeof tooltip !== 'undefined' && (
              <VdsTooltip
                event="hover"
                max-width="250px"
                position="right"
                type="standard"
                text={tooltip}
              >
                <span slot="tooltip-trigger">
                  <VdsIcon svgIcon="information" size="18px" color="color-icon-medium" />
                </span>
              </VdsTooltip>
            )}
          </div>
        </div>

        {action}
      </header>

      {children}
    </section>
  );
}

export default DashboardSection;
